import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import RedirectionModal from '../../../app/common/components/modal/RedirectionModal';
import {useRedirectionModal} from '../../../app/common/components/modal/hooks/useRedirectionModal';
import {useGetMe} from '../../../app/hooks/useGetMe';
import {isClientCIS} from '../../Auth/Utils/CustomerHelper';
import ComingSoon from '../../../app/common/components/ComingSoon';
import { PageTitle } from '../../../_metronic/layout/core';

const EXTRANET_WEB_URL = 'https://extranet2.stella-telecom.fr/web';

const WebHebergementRedirectPage = (): JSX.Element => {
  const intl = useIntl();
  const navigate = useNavigate();
  const customer = useGetMe();
  const {isOpen, closeModal, confirmRedirection, handleContinue, pendingUrl, countdown} =
    useRedirectionModal();

  useEffect(() => {
    if (!customer || isClientCIS(customer)) return;
    confirmRedirection(EXTRANET_WEB_URL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);

  const handleCancel = () => {
    closeModal();
    navigate(-1);
  };

  if (customer && isClientCIS(customer)) {
    return <ComingSoon title="MENU.CLOUD.GROUP_WEB" />;
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CLOUD.GROUP_WEB'})}</PageTitle>
      <RedirectionModal
        show={isOpen}
        onCancel={handleCancel}
        onContinue={handleContinue}
        url={pendingUrl || ''}
        countdown={countdown}
      />
    </>
  );
};

export default WebHebergementRedirectPage;
